import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import AppState from '@webapp/store/state';
import { UpdateTrackField } from '@webapp/store/tracks/action-creators';

import { TrackType } from '@common/types/release/track-type';

import { DropdownCtrl } from '@webapp/controllers/form/dropdown';

import ErrorMessage from '@webapp/components/basics/error-message/index';

interface TrackTypeProps {
  id?: string;
  className?: string;
  validate?: boolean;
  trackId: string;
  locked?: boolean;
}

interface StoreProps {
  type?: TrackType;
  updateType: (value: TrackType) => UpdateTrackField<'type'>;
  updateExplicit: (value?: boolean) => UpdateTrackField<'isExplicit'>;
  updateClean: (value?: boolean) => UpdateTrackField<'isClean'>;
  updateLyrics: (value: string) => UpdateTrackField<'lyrics'>;
}

const mapStateToProps = (state: AppState, props: TrackTypeProps) => ({
  type: state.tracks.tracks[props.trackId].type,
});

const mapDispatchToProps = (dispatch: Dispatch, props: TrackTypeProps) => ({
  updateType: (value: TrackType) =>
    dispatch(new UpdateTrackField<'type'>(props.trackId, 'type', value)),
  updateExplicit: (value?: boolean) =>
    dispatch(
      new UpdateTrackField<'isExplicit'>(props.trackId, 'isExplicit', value)
    ),
  updateClean: (value?: boolean) =>
    dispatch(new UpdateTrackField<'isClean'>(props.trackId, 'isClean', value)),
  updateLyrics: (value: string) =>
    dispatch(new UpdateTrackField<'lyrics'>(props.trackId, 'lyrics', value)),
});

export const TrackTypeCtrl: React.FC<TrackTypeProps & StoreProps> = ({
  validate,
  type,
  locked,
  ...props
}) => {
  const handleChange = (value: TrackType) => {
    props.updateType(value);

    if (value === 'instrumental') {
      props.updateExplicit(undefined);
      props.updateClean(undefined);
      props.updateLyrics('');
    }
  };

  const options = [
    {
      value: 'song',
      label: 'No, this track is not an instrumental',
      helpText: 'This track contains vocals',
    },
    {
      value: 'instrumental',
      label: 'Yes, this track is an instrumental',
      helpText: 'This track has no vocals',
    },
  ];

  return (
    <div>
      <Dropdown
        id={props.id}
        title={<Translate id="RELEASE.TRACK_INFO.TRACK.INSTRUMENTAL" />}
        value={type}
        onChange={(value) => handleChange(value as TrackType)}
        options={options}
        showSelectableOption={true}
        disabled={locked}
      />
      {validate && type === undefined && (
        <ErrorMessage
          className="mt-5"
          hasBackground
          errorId="RELEASE.MISSING_TYPE"
        />
      )}
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackTypeCtrl);

const Dropdown = styled(DropdownCtrl)`
  position: relative;
`;
